<template>
  <b-modal
    id="modal-delete-container"
    title="Hapus"
    size="md"
    centered
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div>Apakah Anda yakin ingin menghapus <strong>1</strong> data berikut?</div>
    <b-list-group class="mt-2">
      <b-list-group-item>
        {{ selectedItem.name }}
      </b-list-group-item>
    </b-list-group>
    <template #modal-footer="{ cancel }">
      <div class="d-flex gap-2">
        <McButton variant="secondary" :text="$t('global.action.cancel')" @click="cancel" />
        <McButton :text="$t('global.delete')" @click="$emit('submit')" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    selectedItem: {
      type: Object,
      required: true,
    }
  },
  emits: ['submit'],
  methods: {
    showModal() {
      this.$bvModal.show('modal-delete-container')
    },
    hideModal() {
      this.$bvModal.hide('modal-delete-container')
    },
  },
}
</script>

<style scoped>
#modal-delete-container {
  .item-wrapper {
    display: flex;
  }
}
</style>